/** Everything an admin-placed order needs before it can be submitted. */
export const canSubmitAdminOrder = (input: {
  customerId: string;
  productId: string;
  loadOptionId: string;
  deliveryAddressId: string;
  isPallet: boolean;
  palletSizeId: string;
  isSubmitting: boolean;
  requiresPo?: boolean;
  poNumber?: string;
}): boolean =>
  !!input.customerId &&
  !!input.productId &&
  !!input.loadOptionId &&
  !!input.deliveryAddressId &&
  (!input.isPallet || !!input.palletSizeId) &&
  (!input.requiresPo || !!input.poNumber?.trim()) &&
  !input.isSubmitting;

/**
 * The checkout body.
 *
 * `quantity: 1` is deliberate — this drawer places one load at a time, and the
 * customer-facing catalog is the only path that derives a quantity from the
 * fulfilment method's capacity.
 */
export const buildAdminOrderPayload = (input: {
  customerId: string;
  productId: string;
  loadOptionId: string;
  isPallet: boolean;
  palletSizeId: string;
  deliveryAddressId: string;
  note: string;
  poNumber: string;
}) => ({
  customerId: input.customerId,
  productId: input.productId,
  loadOptionId: input.loadOptionId,
  quantity: 1,
  palletSizeId: input.isPallet ? input.palletSizeId : null,
  deliveryAddressId: input.deliveryAddressId,
  note: input.note?.trim() ? input.note.trim() : null,
  poNumber: input.poNumber?.trim() ? input.poNumber.trim() : null,
});

/** One delivery address on a line: "Primary • 1 Main St • Newark, NJ 07102 • USA". */
export const addressLabel = (a: any): string => {
  const parts = [
    a.label || (a.isPrimary ? 'Primary' : null),
    a.line1,
    a.line2,
    `${a.city || ''}${a.state ? `, ${a.state}` : ''} ${a.postalCode || ''}`.trim(),
    a.country,
  ].filter(Boolean);

  return parts.join(' • ');
};

/**
 * How a customer reads in the picker. Falls all the way through to the id
 * rather than rendering a blank row.
 */
export const customerLabel = (c: any): string =>
  c?.name || c?.companyName || c?.fullName || c?.email || c?.id;
